import { render, staticRenderFns } from "./ResidentDaysEditor.vue?vue&type=template&id=3fd5edbc&"
import script from "./ResidentDaysEditor.vue?vue&type=script&lang=js&"
export * from "./ResidentDaysEditor.vue?vue&type=script&lang=js&"
import style0 from "./ResidentDaysEditor.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports